export const getSettings = () => ({
  minReservationHours: parseInt(process.env.NEXT_PUBLIC_MIN_RESERVATION_HOURS || '3', 10),
  maxReservationDays: parseInt(process.env.NEXT_PUBLIC_MAX_RESERVATION_DAYS || '60', 10),
  minReservationOffsetHours: parseFloat(process.env.NEXT_PUBLIC_MIN_RESERVATION_OFFSET_HOURS || '2'),
  minutesStep: 30,
  businessHours: {
    start: process.env.NEXT_PUBLIC_BUSINESS_HOURS_START || '09:00',
    end: process.env.NEXT_PUBLIC_BUSINESS_HOURS_END || '20:00',
  },
  lastTodayReservationHour: parseInt(process.env.NEXT_PUBLIC_LAST_TODAY_RESERVATION_HOUR || '15', 10), // renamed for clarity
  depositPercentage: parseInt(process.env.NEXT_PUBLIC_DEPOSIT_PERCENTAGE || '20', 10),
});